import Vue from 'vue';

const success = (response, context) => {
    context.rentals = response.data.rentals;
    if (context.uninitialized_count !== undefined) {
        context.uninitialized_count = response.data.uninitialized_count;
    }
    context.uninitialized_count = response.data.uninitialized_count;
    context.loading = false;
    if (context.uninitialized_count !== undefined) {
        context.user = response.data.user;
    }
};

const failed = (error, context) => {
  // toastr.error(error.data.msg);
};

export default (context, messageAccess = '') => {
    return Vue.$http.get(`/get-rentals-list?permission=true&messageAccess=${messageAccess}`)
        .then((response) => {
            if (response && response.status === 200) {
                success(response, context);
            }
    })
    .catch((error) => {
        failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/getRentalsList.js